import { useTranslation } from "react-i18next";
import Icon from "../Icon";
import { COMPARE_COLUMNS, COMPARE_ROWS } from "../../data/tools";
import { useL } from "../../lib/useLang";

const MARKS = {
  yes: { icon: "check-circle", className: "fsg-mark-yes", key: "yes" },
  partial: { icon: "minus", className: "fsg-mark-partial", key: "partial" },
  no: { icon: "close", className: "fsg-mark-no", key: "no" },
};

export default function Comparator() {
  const { t } = useTranslation();
  const L = useL();

  return (
    <div>
      <p style={{ fontSize: "var(--fsg-fs-sm)" }}>{t("comparator.intro")}</p>

      <div className="fsg-table-wrap">
        <table className="fsg-table">
          <caption className="fsg-sr-only">{t("comparator.title")}</caption>
          <thead>
            <tr>
              <th scope="col">{t("comparator.need")}</th>
              {COMPARE_COLUMNS.map((column) => (
                <th scope="col" key={column.id}>
                  {L(column.name)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {COMPARE_ROWS.map((row) => (
              <tr key={L(row.need)}>
                <th scope="row">{L(row.need)}</th>
                {COMPARE_COLUMNS.map((column) => {
                  const mark = MARKS[row.values[column.id]] ?? MARKS.no;
                  return (
                    <td key={column.id}>
                      <span className={mark.className}>
                        <Icon name={mark.icon} />
                        <span className="fsg-sr-only">
                          {t(`comparator.${mark.key}`)}
                        </span>
                      </span>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="fsg-compare__legend">
        <span>
          <Icon name="check-circle" className="fsg-mark-yes" />{" "}
          {t("comparator.yes")}
        </span>
        <span>
          <Icon name="minus" className="fsg-mark-partial" />{" "}
          {t("comparator.partial")}
        </span>
        <span>
          <Icon name="close" className="fsg-mark-no" /> {t("comparator.no")}
        </span>
      </div>
    </div>
  );
}
